import { Buffer } from "buffer";
export const unqClubSeed = Buffer.from("unq-club");
export const monkeAuthoritySeed = Buffer.from("monke-authority");
export const monkeAdminSeed = Buffer.from("monke-admin");
window.Buffer = Buffer;
